import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import { CreateClientCommand, DeleteClientCommand, GetClientsRequest, GetClientsResponse, UpdateClientCommand } from "../model/clientModel";
import { apiCreateClient, apiDeleteClient, apiGetClients, apiUpdateClient } from "../async/clientAsync";


export const getClients = createAsyncThunk<GetClientsResponse, GetClientsRequest, { state: RootState, rejectValue: string }>('clients/GET_CLIENTS', 
    async (payload: GetClientsRequest, { getState, rejectWithValue }) => {
        const token = getState().auth.user?.token ?? "";
        return await apiGetClients(token, payload, rejectWithValue);
    }
);

export const createClient = createAsyncThunk<void, CreateClientCommand, { state: RootState, rejectValue: string }>('clients/CREATE_CLIENT', 
    async (payload: CreateClientCommand, { getState, rejectWithValue }) => {
        const token = getState().auth.user?.token ?? "";
        return await apiCreateClient(token, payload, rejectWithValue);
    }
);

export const updateClient = createAsyncThunk<void, UpdateClientCommand, { state: RootState, rejectValue: string }>('clients/UPDATE_CLIENT', 
    async (payload: UpdateClientCommand, { getState, rejectWithValue }) => {
        const token = getState().auth.user?.token ?? "";
        return await apiUpdateClient(token, payload, rejectWithValue);
    }
);

export const deleteClient = createAsyncThunk<void, DeleteClientCommand, { state: RootState, rejectValue: string }>('clients/DELETE_CLIENT', 
    async (payload: DeleteClientCommand, { getState, rejectWithValue }) => {
        const token = getState().auth.user?.token ?? "";
        return await apiDeleteClient(token, payload, rejectWithValue);
    }
);

export const resetUpdateSuccess = createAction("client/RESET_SAVE_SUCCESS");
export const resetDeleteSuccess = createAction("client/RESET_DELETE_SUCCESS");

export const resetCreateFailure = createAction("client/RESET_CREATE_FAILURE");